import request from "@/utils/request";

/**
 * 关于冀华
 */
export function aboutInfo({type = 'introduction'}) {
    return request({
        url: "/api/about/info?type=" + type,
        method: "get",
    });
}

/**
 * 关于冀华
 * 荣誉不要图片
 */
export function aboutInfo1({type = 'introduction'}) {
    return request({
        url: "/api/about/info1?type=" + type,
        method: "get",
    });
}
